<template>
  <td class="table-image-cell">
    <template v-if="imageSource">
      <template v-if="type == 'image' || type == 'video'">
        <div @click.stop.prevent="clicked(value)" class="image-wrapper">
          <ux-image
            lazy
            :item="imageSource"
            :type="type"
            :width="100"
            :height="100"
          />
        </div>
      </template>
      <template v-else-if="type === 'audio'">
        <ux-icon icon="fa-music" />
      </template>
      <template v-else-if="type === 'file'">
        <ux-icon icon="fa-file" />
      </template>
      <template v-else>
        <div @click.stop.prevent="clicked(value)" class="image-wrapper">
          <ux-image
            lazy
            :item="imageSource"
            :type="type"
            :width="100"
            :height="100"
          />
        </div>
      </template>
    </template>
  </td>
</template>
<script>
import TableCellMixin from "./TableCellMixin.js";
import _get from "lodash/get";

export default {
  mixins: [TableCellMixin],
  computed: {
    key() {
      return this.column.key;
    },
    rawSource() {
      return _get(this.row, this.key);
    },
    source() {
      if (Array.isArray(this.rawSource)) {
        return this.rawSource[0];
      } else {
        if (this.rawSource) {
          return this.rawSource;
        } else {
          return this.row;
        }
      }
    },
    imageSource() {
      const source = this.source;

      if (!source) {
        return;
      }

      switch (source?.meta?.type) {
        case "video":
        case "image":
        case "event":
        case "persona":
        case "profile":
        case "audio":
        case "file":
          return this.source;
          break;
        default:
          {
            const sourceID = this.$sdk.utils.id(this.source);

            if (!sourceID) {
              return;
            }

            var slicedHexKey = sourceID.slice(8, 10);
            switch (slicedHexKey) {
              case "69":
                return {
                  _id: sourceID,
                  meta: {
                    type: "image",
                  },
                };
                break;
              case "76":
                return {
                  _id: sourceID,
                  meta: {
                    type: "video",
                  },
                };
                break;
              case "24":
                return {
                  _id: sourceID,
                  meta: {
                    type: "persona",
                  },
                };
                break;
              case "70":
                return {
                  _id: sourceID,
                  meta: {
                    type: "profile",
                  },
                };
                break;
              case "71":
                return {
                  _id: sourceID,
                  meta: {
                    type: "checkin",
                  },
                };
                break;
            }

            return sourceID;
          }
          break;
      }
    },
    type() {
      return this.imageSource?.meta?.type;
    },
  },
  methods: {
    clicked(item) {
      this.$sdk.dispatch("item:view", this.imageSource);
    },
  },
};
</script>

<style scoped lang="scss">
td {
  min-width: 60px;
  width: 60px;
  padding: 0.3em !important;

  .image-wrapper {
    width: 50px;
    height: 50px;
    cursor: pointer;
  }
  .ux-image {
    border-radius: 0.1em;
  }

  text-align: center;
}
</style>
